exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3yafWMLo6akJd3gGtFCGo0{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:100%}._2FTbzvd9ewnFiPYIwaDNk-{display:inline-block;line-height:1}._2wZPx7oknaoNKvLZqGP-n0{color:\"[theme:themePrimary, default:#0078D4]\"}html[dir=ltr] ._2wZPx7oknaoNKvLZqGP-n0{margin-right:8px}html[dir=rtl] ._2wZPx7oknaoNKvLZqGP-n0{margin-left:8px}", ""]);

// exports
exports.locals = {
	"darkModeToggle": "_3yafWMLo6akJd3gGtFCGo0",
	"label": "_2FTbzvd9ewnFiPYIwaDNk-",
	"icon": "_2wZPx7oknaoNKvLZqGP-n0"
};